import { render, staticRenderFns } from "./IndustryCreateUpdate.vue?vue&type=template&id=6c2da404&"
import script from "./IndustryCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./IndustryCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports